/**
 * Created by shiyonggao on 2019/2/25.
 */
const handler = {
    getUrl(key, platform, rootState) {
        let system = rootState.$config.api.system;
        return system[key].replace(/\{platform\}/g, platform);
    }
}

/**
 * state 中的方法命名规则（小驼峰规则）
 */
const state = {
    iosVersionList: [],
    iosVersionListLen: 0,
    iosVersionLast: {},

    androidVersionList: [],
    androidVersionListLen: 0,
    androidVersionLast: {},

    h5VersionList: [],
    h5VersionListLen: 0,
    h5VersionLast: {},

    windowsVersionList: [],
    windowsVersionListLen: 0,
    windowsVersionLast: {},
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
const actions = {
    ADD_BASE_VERSION({state, commit, dispatch, rootState}, args){
        commit('PRIVATE_LOADING', true, {root: true});
        let url = handler.getUrl('add_version', args.platform, rootState);
        rootState.$helper.request.put(url, args.data)
        .then(res=>{
            commit('PRIVATE_LOADING', false, {root: true});
            dispatch('ALERT_HANDLE', {message: '添加版本成功！',reload: true}, {root: true});
        }).catch((error)=>{
            let message = '操作失败！';
            if(error['response']
                && error['response']['data']
                && error['response']['data']['exception']
                && error['response']['data']['exception']['message']
            ){
                message = error['response']['data']['exception']['message'];
            }
            commit('PRIVATE_LOADING', false, {root: true});
            dispatch('ALERT_HANDLE', {message: message}, {root: true});
        })
    },

    EDIT_BASE_VERSION({state, commit, dispatch, rootState}, args) {
        commit('PRIVATE_LOADING', true, {root: true});
        let version_id = args.item['sdk_version_id'];
        let url = handler.getUrl('edit_version', args.item.platform, rootState);
        url = url.replace(/\{sdk_version_id\}/g, version_id);
        rootState.$helper.request.put(url, args.data)
        .then(res=>{
            commit('PRIVATE_LOADING', false, {root: true});
            dispatch('ALERT_HANDLE', {message: '编辑版本成功！', reload: true}, {root: true});
        }).catch(res=>{
            commit('PRIVATE_LOADING', false, {root: true});
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },

    /**
     * 删除版本号
     * @constructor
     */
    REMOVE_BASE_VERSION({state, commit, dispatch, rootState},item) {
        commit('PRIVATE_LOADING', true, {root: true});
        let version_id = item['sdk_version_id'];
        let url = handler.getUrl('remove_version',item['platform'], rootState);
        url = url.replace(/\{sdk_version_id\}/g, version_id);
        rootState.$helper.request.delete(url)
        .then((res)=>{
            commit('PRIVATE_LOADING', false, {root: true});
            dispatch('ALERT_HANDLE', {message: '删除成功！', reload: true}, {root: true});
        })
        .catch((res)=>{
            commit('PRIVATE_LOADING', false, {root: true});
            dispatch('ERROR_HANDLE', res, {root: true});
        })
    },

    /**
     * 获取所有版本号列表
     * @constructor
     */
    GET_BASE_VERSION_LIST({commit, dispatch, rootState}) {
        commit('PRIVATE_LOADING',true,{root: true});
        let url = handler.getUrl('get_version_list', 'all', rootState);
        let data = {
            iosVersionList : [],
            androidVersionList: [],
            h5VersionList: [],
            windowsVersionList: [],
            iosVersionListLen: 0,
            androidVersionListLen: 0,
            h5VersionListLen: 0,
            windowsVersionListLen: 0,
        };
        rootState.$helper.request.get(url)
        .then((res)=>{
            for(let key in res.data['sdk_versions']){
                if(res.data['sdk_versions'][key]['platform'] === 'iOS'){
                    data.iosVersionList.push(res.data['sdk_versions'][key]);
                    data.iosVersionListLen += 1;
                }

                if (res.data['sdk_versions'][key]['platform'] === 'Android') {
                    data.androidVersionList.push(res.data['sdk_versions'][key]);
                    data.androidVersionListLen += 1;
                }

                if (res.data['sdk_versions'][key]['platform'] === 'H5') {
                    data.h5VersionList.push(res.data['sdk_versions'][key]);
                    data.h5VersionListLen += 1;
                }
                if (res.data['sdk_versions'][key]['platform'] === 'Windows') {
                    data.windowsVersionList.push(res.data['sdk_versions'][key]);
                    data.windowsVersionListLen += 1;
                }
            }
            commit('_updateVersion', data);
            commit('PRIVATE_LOADING', false, {root: true});
        }).catch((res)=>{
            dispatch('ERROR_HANDLE', res, {root: true});
            commit('PRIVATE_LOADING', false, {root: true});
        });
    },

};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
const getters = {

};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
const mutations = {
    _updateVersion(state,data){
        state.iosVersionList = data.iosVersionList;
        state.iosVersionListLen = data.iosVersionListLen;
        state.iosVersionLast = data.iosVersionList[0];

        state.androidVersionList = data.androidVersionList;
        state.androidVersionListLen = data.androidVersionListLen;
        state.androidVersionLast = data.androidVersionList[0];

        state.h5VersionList = data.h5VersionList;
        state.h5VersionListLen = data.h5VersionListLen;
        state.h5VersionLast = data.h5VersionList[0];

        state.windowsVersionList = data.windowsVersionList;
        state.windowsVersionListLen = data.windowsVersionListLen;
        state.windowsVersionLast = data.windowsVersionList[0];
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./website/store/modules/system/sdkVersion.js